import { useSiteBrand } from '../i18n'

/** Код палитры тайлов домена; `null` — домен красит нашей гаммой.
 *
 *  Отдельный хук, а не чтение бренда на месте: значение уходит В ЗАВИСИМОСТИ
 *  мемоизации адреса тайла. Модульная переменная была бы короче, но адрес
 *  пересобирается по `useCallback`, и палитра, приехавшая после первого кадра,
 *  осталась бы за бортом — карта показала бы нашу гамму до следующего действия
 *  человека.
 */
export function useTilePalette(): string | null {
  return useSiteBrand()?.palette_code ?? null
}
